module.exports = __webpack_public_path__ + "static/media/top_green.e34a0307.png";